import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from "react-redux";
import store from "./store";
import * as serviceWorker from './serviceWorker';
import 'mdbreact/dist/css/mdb.css';
import 'bootstrap/dist/css/bootstrap.css';
// import '@fortawesome/fontawesome-free/css/all.min.css';
import 'react-toastify/dist/ReactToastify.css';
import 'react-toastify/dist/ReactToastify.minimal.css';

// import * as Sentry from "@sentry/react";
import App from './App';
import axios from 'axios';
import WrapperContext from "./context/Wrapper";

axios.defaults.baseURL = (process.env.REACT_APP_BACKEND_URL || 'http://localhost:5001') + '/api/';
axios.interceptors.request.use(request => {
    // console.log(request.baseURL+request.url);
    // request.headers.Authorization = `Bearer`
    return request
}, error => {
    // console.log(error.message);
    return Promise.reject(error);
});

// Sentry.init({ dsn: "https://1e9879ce447c4ccbb2c0ab4ab160d03e@o447621.ingest.sentry.io/5427683" });

ReactDOM.render(
    <WrapperContext>
        <Provider store={store}>
            <App/>
        </Provider>
    </WrapperContext>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
